import axiosClient from './axiosClient';

async function requestPrivateTransfer(requestBody: ISaveNoticeRequest) {
  try {
    const response = await axiosClient.post('/upgrades/private-transfer-request', requestBody);
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default requestPrivateTransfer;
